(function () {
  'use strict';
  var section = document.querySelector('[data-tpl-craft-qa]');
  if (!section) return;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var checklist = section.querySelector('[data-qa-checklist]');
  if (checklist) {
    var checks = section.querySelectorAll('[data-qa-check]');
    var checkObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (reducedMotion) {
            checks.forEach(function (c) { c.classList.add('is-checked'); c.setAttribute('aria-checked', 'true'); });
          } else {
            checks.forEach(function (check) {
              var delay = parseInt(check.style.getPropertyValue('--qa-delay')) || 0;
              setTimeout(function () { check.classList.add('is-checked'); check.setAttribute('aria-checked', 'true'); }, delay);
            });
          }
          checkObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    checkObserver.observe(checklist);
  }
  var liveRegion = section.querySelector('.tpl-craft-qa__live');
  function announce(text) { if (liveRegion) liveRegion.textContent = text; }
  section.querySelectorAll('[data-qa-check]').forEach(function (el) {
    function toggle() {
      var checked = el.classList.toggle('is-checked');
      el.setAttribute('aria-checked', checked ? 'true' : 'false');
      var label = el.querySelector('.tpl-craft-qa__label');
      if (label) announce((checked ? 'Checked: ' : 'Unchecked: ') + label.textContent);
    }
    el.addEventListener('click', toggle);
    el.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); } });
  });
})();
